import { IStoreState, ThunkDispatch } from "../../modules";
import React, { Component, Fragment } from "react";
import { RequestArgs, analyze } from "../../modules/api";
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { Transaction, TransactionMedium } from "../../types/transaction";

import { Account } from "../../modules/accounts";
import Button from '@material-ui/core/Button';
import { ChallengeResult } from "../../modules/challenge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import NumberFormat from 'react-number-format';
import Paper from '@material-ui/core/Paper';
import { Payee } from "../../modules/payees";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";

const styles = (theme: Theme) => createStyles({
  root: {
  },
  stepLabelClickable: {
    cursor: 'pointer',
  },
  confirmationSection: {
    textAlign: 'center',
    marginTop: theme.spacing(4)
  },
  actionButtons: {
    margin: theme.spacing(2)
  },
  resetButton: {
    margin: `${theme.spacing(4)}px auto ${theme.spacing(1)}px`,
    display: 'block',
  },
  summaryText: {
    fontWeight: "normal",
  },
  error: {
    color: theme.palette.error.main,
    textAlign: 'center',
    padding: `0 0 ${theme.spacing(2)}px`,
  },
  complete: {
    padding: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(1),
  },
  paperHeader: {
    margin: theme.spacing(2),
    color: '#666'
  },
  headerIcon: {
    marginRight: theme.spacing(2),
  },
})

type State = {
  activeStep: number
  medium: TransactionMedium | null
  payee: Payee | undefined
  source: Account | undefined
  amount: number | null
  transfer: Transaction | null
  error: string
}

const initial_state: State = {
  activeStep: 0,
  medium: null,
  payee: undefined,
  source: undefined,
  amount: null,
  transfer: null,
  error: ''
}

class TransferPane extends Component<Props, State> {

  constructor(props: Props) {
    super(props)
    this.state = initial_state
  }

  componentDidMount = () => {
    document.title = "Make a Transfer"
  }

  handleMediumChange = (e: React.ChangeEvent<{}>) => {
    this.setState({
      medium: (e.target as HTMLInputElement).value as TransactionMedium,
    })
    this.proceed();
  }

  handleSourceChange = (e: any) => {
    let accounts = this.props.accounts.list

    this.setState({
      source: accounts.find((a: Account) => a.id === e.target.value),
    })
    this.proceed();
  }

  handlePayeeChange = (payeeList: Payee[]) => (e: any) => {
    this.setState({
      payee: payeeList.find((a: Payee) => a.accountNumber === e.target.value),
    })
    this.proceed();
  }

  handleAmountChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      amount: parseFloat(e.target.value),
    })
  }

  handleBlur(e: React.FocusEvent) {
    let target = e.target as HTMLInputElement

    if (target.value !== "")
      this.proceed();
  }

  proceed() {
    this.setState({
      activeStep: this.state.activeStep + 1,
    })
  }
  goToStep(step: number) {
    const { medium, source, payee, amount } = this.state

    if (this.state.activeStep > step)
      this.setState({
        activeStep: step,
        medium: step <= 0 ? initial_state.medium : medium,
        source: step <= 1 ? initial_state.source : source,
        payee: step <= 2 ? initial_state.payee : payee,
        amount: step <= 3 ? initial_state.amount : amount,
      })
  }

  transfer() {
    const { medium, source, payee, amount } = this.state

    let transfer = {
      medium,
      source,
      payee,
      amount,
      complete: false,
    } as Transaction

    let args: RequestArgs = {
      eventDataList: {
        eventData: {
          eventType: "PAYMENT",
          transactionData: {
            amount: {
              amount: (transfer.amount * 100).toString(),
              currency: transfer.source.currency,
            },
            executionSpeed: "REAL_TIME",
            myAccountData: {
              accountNickName: transfer.source.name,
              accountNumber: transfer.source.id,
              accountType: "CHECKING",
            },
            otherAccountBankType: transfer.medium === TransactionMedium.Internal ? "SAME_BANK" : "OTHER_BANK",
            otherAccountData: {
              accountNickName: transfer.payee.accountNickName,
              accountNumber: transfer.payee.accountNumber,
              routingCode: transfer.payee.routingCode,
            },
            otherAccountOwnershipType: transfer.medium === TransactionMedium.Internal ? "ME_TO_ME" : "ME_TO_YOU",
            otherAccountType: "PERSONAL_ACCOUNT",
            recurringFrequency: "0",
            schedule: "IMMEDIATE",
            transferMediumType: transfer.medium,
          }
        }
      }
    }

    let { analyzePromise, challengePromise } = this.props.analyze(args)

    analyzePromise.catch(err => {
      console.error(err)
      throw err
    })
      .then((result) => {

        if (result.actionCode === "DENY")
          this.setState({
            error: "Action denied"
          })
        else
          challengePromise.then(result => {
            if (result === ChallengeResult.Failure)
              throw new Error("Challenge failed, please try again")
            if (result === ChallengeResult.Error)
              throw new Error("Challenge error, please try again")

            // Challenge success!
            this.setState({ transfer: { ...transfer, complete: true } as Transaction, error: "" })
          }).catch(error => {
            this.setState({ error: error.message })
          })
      })
    return true
  }

  transactionMediumNames: { [medium in TransactionMedium]: string } = {
    [TransactionMedium.Internal]: 'Internal',
    [TransactionMedium.BillpayMail]: 'Mail Billpay',
    [TransactionMedium.BillpayElectronic]: 'Electronic Billpay',
    [TransactionMedium.BalanceTransfer]: 'Balance Transfer',
    [TransactionMedium.ACH]: 'ACH',
    [TransactionMedium.Wire]: 'Domestic Wire',
    [TransactionMedium.InternationalWire]: 'International Wire',
    [TransactionMedium.Check]: 'Check'
  }

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale
        prefix="$"
      />
    );
  }

  reset() {
    this.setState(initial_state)
  }

  formatSource(a: Account) {
    const { intl } = this.props

    return `${a.name} (${new Intl.NumberFormat(intl.locale, { style: 'currency', currency: a.currency }).format(a.balance)})`
  }

  formatPayee(p: Payee) {
    return `${p.accountNickName} (${p.accountNumber})`
  }

  render() {
    const { accounts, classes, intl, payees } = this.props
    const { activeStep, medium, payee, source, amount, transfer, error } = this.state

    let payeeList = payees.list.concat(accounts.list.filter(account => account.type === "deposit").map(account => ({
      accountNumber: account.id,
      accountNickName: account.name,
      routingCode: "",
      medium: TransactionMedium.Internal
    } as Payee)))

    payeeList = payeeList.filter((p: Payee) => p.medium === medium && (!source || p.accountNumber !== source.id))

    let payeeOutput: JSX.Element[] = []

    if (payeeList)
      payeeOutput = payeeList.map((payee: Payee, k: number) => <option key={k} value={payee.accountNumber}>{this.formatPayee(payee)}</option>)

    const accountList = accounts.list.filter((a: Account) => a.type === 'deposit');
    let accountOutput = accountList.map((a: Account) => <option key={a.id} value={a.id}>{this.formatSource(a)}</option>);

    const renderSummary = (summary: string) =>
      <Fragment>: <Typography className={classes.summaryText}>{summary}</Typography></Fragment>

    const CustomStepLabel = ({ step, summary, prompt, ...props }: { step: number, summary: string, prompt: string, children: JSX.Element | string }) =>
      <StepLabel orientation="vertical" onClick={this.goToStep.bind(this, step)} className={activeStep > step ? classes.stepLabelClickable : ''} {...props}>
        {activeStep === step && prompt}
        {activeStep !== step &&
          <Fragment>
            {props.children}{summary && renderSummary(summary)}
          </Fragment>
        }
      </StepLabel>

    return (
      <div className={classes.root}>
        {/*<Typography variant="h4" id="pageHeader">Make a Transfer</Typography>*/}
        <Paper className={classes.paper}>
          <Typography variant="h4" className={classes.paperHeader}><FontAwesomeIcon icon={faExchangeAlt} className={classes.headerIcon} /> Make a Transfer</Typography>
          {(!transfer || !transfer.complete) &&
            <Stepper activeStep={this.state.activeStep} orientation="vertical">
              <Step>
                <CustomStepLabel step={0} prompt="I want to transfer funds:" summary={medium ? this.transactionMediumNames[medium] || "" : ""}>Type</CustomStepLabel>
                <StepContent>
                  <FormControl>
                    <RadioGroup
                      aria-label="Transfer Type"
                      name="medium"
                      onChange={this.handleMediumChange}
                    >
                      <FormControlLabel value={`${TransactionMedium.Internal}`} control={<Radio />} label="between my accounts" />
                      <FormControlLabel value={`${TransactionMedium.Wire}`} control={<Radio />} label="to a local bank account" />
                      <FormControlLabel disabled value={`${TransactionMedium.InternationalWire}`} control={<Radio />} label="to an overseas account" />
                      <FormControlLabel value={`${TransactionMedium.BillpayElectronic}`} control={<Radio />} label="to a billing organization" />
                    </RadioGroup>
                  </FormControl>
                </StepContent>
              </Step>
              <Step>
                <CustomStepLabel prompt="Transfer from:" step={1} summary={source && accountList ? this.formatSource(source) : ""}>Source</CustomStepLabel>
                <StepContent>
                  <FormControl>
                    <Select
                      native
                      onChange={this.handleSourceChange}
                      input={<Input name="sourceAccount" id="sourceAccount" />}
                    >
                      <option value="" />
                      {accountOutput}
                    </Select>
                  </FormControl>
                </StepContent>
              </Step>
              <Step>
                <CustomStepLabel prompt="Transfer to:" step={2} summary={payee ? this.formatPayee(payee) : ""}>Destination</CustomStepLabel>
                <StepContent>
                  <FormControl>
                    <Select
                      native
                      onChange={this.handlePayeeChange(payeeList)}
                      input={<Input name="payee" id="payee" />}
                    >
                      <option value="" />
                      {payeeOutput}
                    </Select>
                  </FormControl>
                </StepContent>
              </Step>
              <Step>
                <CustomStepLabel prompt="Enter the transaction amount: " step={3} summary={amount && source ? new Intl.NumberFormat(intl.locale, { style: 'currency', currency: source.currency }).format(amount) : ""}>Amount</CustomStepLabel>
                <StepContent>
                  <FormControl fullWidth>
                    <TextField
                      label="Transaction amount"
                      onChange={this.handleAmountChange.bind(this)}
                      onBlur={this.handleBlur.bind(this)}
                      id="amount"
                      InputProps={{
                        inputComponent: this.NumberFormatCustom,
                      }}
                      inputProps={{
                        pattern: "\\d*",
                      }}
                    />
                  </FormControl>
                </StepContent>
              </Step>
              <Step>
                <CustomStepLabel prompt="Please confirm the transaction details above " step={4} summary={""}>Confirmation</CustomStepLabel>
                <StepContent className={classes.confirmationSection}>
                  {error && <Typography className={classes.error} variant="subtitle2">{error}</Typography>}
                  <Button variant="contained" color="secondary" onClick={this.reset.bind(this)} className={classes.actionButtons}>Cancel</Button>
                  <Button variant="contained" color="primary" onClick={this.transfer.bind(this)} className={classes.actionButtons}>Transfer</Button>
                </StepContent>
              </Step>
            </Stepper>
          }
          {transfer && transfer.complete && source && payee && amount &&
            <div className={classes.complete}>
              <Typography variant="body1">You have successfully transferred <strong>{new Intl.NumberFormat(intl.locale, { style: 'currency', currency: source.currency }).format(amount)}</strong> to <strong>{(payee as Payee).accountNickName}</strong> from your <strong>{(source as Account).name}</strong></Typography>
              <Button color="primary" onClick={() => {this.setState(initial_state)}} className={classes.resetButton}>Make another transfer</Button>
            </div>
          }
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = ({ accounts, intl, payees }: IStoreState) => ({
  accounts,
  intl,
  payees,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      analyze
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TransferPane));